module.exports = __webpack_public_path__ + "media/application/images/ui/dont-buy-543549f96c50e005d4c7f9ea3b37d510.png";